import { Archive, ArchiveRestore, CloudOff, CloudUpload } from "lucide-react";
import type { WindowAction } from "./RecordWindow";

/*
 * The actions most windows offer (RecordWindow's More menu), the same everywhere: archive or
 * restore a record, and remove it from ServiceM8 (archived there, kept here) or add it back. Each
 * says what happens before it's done. `kind` names it ("item", "supplier"); `name`, which one.
 */

const IN_JOBS: Record<string, string> = { item: " and can't be added to jobs", bundle: " and can't be added to jobs" };

/** Archive it (hidden in ServiceM8 and here: a danger) or, archived, restore it. */
export function archiveAction(kind: string, name: string, active: boolean, onChange: (active: boolean) => void): WindowAction {
    if (active) {
        return {
            icon: <Archive className="size-4" />,
            label: "Archive",
            help: "Hides it in ServiceM8 and here. It can be restored.",
            danger: true,
            confirm: {
                title: `Archive this ${kind}?`,
                subject: name,
                message: `It's hidden in ServiceM8 and here${IN_JOBS[kind] ?? ""}. You can restore it any time.`,
                confirmLabel: "Archive",
            },
            run: () => onChange(false),
        };
    }
    return {
        icon: <ArchiveRestore className="size-4" />,
        label: "Restore",
        help: "Shows it in ServiceM8 and here again.",
        confirm: { title: `Restore this ${kind}?`, subject: name, message: "It shows in ServiceM8 and here again.", confirmLabel: "Restore" },
        run: () => onChange(true),
    };
}

/**
 * Remove it from ServiceM8 (a danger: archived there, kept here) or, only here, add it to ServiceM8.
 * Null when it can't be added now (`unavailable`); offered but off while it's archived.
 */
export function syncAction(kind: string, name: string, synced: boolean, active: boolean, unavailable: string | null | undefined, onChange: (enabled: boolean) => void): WindowAction | null {
    if (synced) {
        return {
            icon: <CloudOff className="size-4" />,
            label: "Remove from ServiceM8",
            help: "Archives it in ServiceM8. It stays here, and can be added back.",
            danger: true,
            disabled: !active,
            confirm: {
                title: `Remove this ${kind} from ServiceM8?`,
                subject: name,
                message: "It stays here, but it's archived in ServiceM8. You can add it back any time.",
                confirmLabel: "Remove from ServiceM8",
            },
            run: () => onChange(false),
        };
    }
    if (unavailable) return null;
    return {
        icon: <CloudUpload className="size-4" />,
        label: "Add to ServiceM8",
        help: "Puts it in ServiceM8 with its details from here.",
        disabled: !active,
        confirm: { title: `Add this ${kind} to ServiceM8?`, subject: name, message: "It's put in ServiceM8 with the values here.", confirmLabel: "Add to ServiceM8" },
        run: () => onChange(true),
    };
}
